<div class="alert-container">
    <div class="alert alert-{{alert.type}} fade show" [ngClass]="{'alert-dismissible': alert.dismissible}" role="alert" *ngIf="alert">
        {{alert.message}}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" *ngIf="alert.dismissible"></button>
    </div>
</div>